import Api from "..";

const getPontos = async (useFilter = false) => {
    try {
        const idUsuario = typeof window !== 'undefined' ? localStorage.getItem('idUsuario') : null;
    const url = (useFilter && idUsuario) ? `pontos/listarPontos?idUsuario=${idUsuario}` : 'pontos/listarPontos';
        const response = await Api.get(url);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar pontos: ${error.message}`);
    }
}

const getPontoById = async (id) => {
    try {
        const response = await Api.get(`/pontos/buscarPontoPorId?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar ponto com ID ${id}: ${error.message}`);
    }
}

const createPonto = async (pontoData) => {
    try {
        const response = await Api.post("/pontos/criarPonto", pontoData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao criar ponto: ${error.message}`);
    }
}

const updatePonto = async (id, pontoData) => {
    try {
        const response = await Api.patch(`/pontos/atualizarPonto?id=${id}`, pontoData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao atualizar ponto com ID ${id}: ${error.message}`);
    }
}

const inativarPonto = async (id, dadosInativacao) => {
    try {
        const response = await Api.patch(
            `/pontos/inativarPonto?id=${id}`,
             dadosInativacao
        );
        return response.data;
    } catch (error) {
        throw new Error(
            `Erro ao inativar ponto com ID ${id}: ${
                error.response?.data?.detalhes || error.message
            }`
        );
    }
}

const reativarPonto = async (id) => {
    try {
        const response = await Api.patch(`/pontos/reativarPonto?id=${id}`, {});
        return response.data;
    } catch (error) {
        throw new Error(
            `Erro ao reativar ponto com ID ${id}: ${
            error.response?.data?.detalhes || error.message
            }`
        );

    }
}

async function deletePonto(id) {
    try {
        const response = await Api.delete(`/pontos/deletarPonto?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao deletar ponto com ID ${id}: ${error.message}`);
    }
}

export default {
    getPontos,  
    getPontoById,
    createPonto,
    updatePonto,
    inativarPonto,
    reativarPonto,
    deletePonto
};